import React, {Component} from 'react'
import './Header.css'

class Header extends Component {
  render() {
    return (
      <div className="header">
        <h1>chordial.us</h1>
        <h2>piano chord charts</h2>
      </div>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Header.js